import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import {
    IonicApp,
    IonicErrorHandler,
    IonicModule,
    IonicPageModule
} from "ionic-angular";

import { SelectSearchableModule } from 'ionic-select-searchable';

 
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
//import { IonicStorageModule } from "@ionic/storage";
import { NgPipesModule } from "ngx-pipes";
import { SearchPipe } from "../common/pipes/search";
import { TimeagoModule } from "ngx-timeago";
import { AvatarModule } from "ng2-avatar";
import { ConfirmationPopoverModule } from "angular-confirmation-popover";
import { TimeAgoPipe } from "time-ago-pipe";

import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Keyboard } from "@ionic-native/keyboard";
import { Network } from "@ionic-native/network";
import { Diagnostic } from "@ionic-native/diagnostic";

// Geo Location plugins
import { Geolocation } from "@ionic-native/geolocation";
import { BackgroundMode } from "@ionic-native/background-mode";
import { BackgroundGeolocation } from "@ionic-native/background-geolocation";
// END

import { MyApp } from "./app.component";
import { InterceptureService } from "./intercepture.service";
import { HomePage } from "../pages/home/home";
import { MapPage } from "../pages/map/map";
import { Mixpanel } from "@ionic-native/mixpanel";

import { LocationTracker } from "./../common/services/location-tracker";
import { SocketioService } from "./../common/services/socketio.service";
import { NotificationsService } from "./../common/services/notifications/notifications.service";
import { Shutdown } from "./../common/services/shutdown";

import { AppVersion } from "@ionic-native/app-version";
import { Market } from "@ionic-native/market";

import { ProductsPage } from "../pages/products/products";
import { LoginPage } from "../pages/login/login";
import { APIServiceProvider } from "./../common/services/api.service";
import { HelperServiceProvider } from "./../common/services/helper.service";
import { OrderplacedPage } from "../pages/orders/orderplaced/orderplaced";
import { TabOrder } from "../pages/orders/tabs/tab-order";
import { TabAddOrder } from "../pages/addorder/tabs/tab-addorder";
import { TabSettlement } from "../pages/settlement/tabs/tab-settlement";
import { TabInventory } from "../pages/inventory/tabs/tab-inventory";
import { TabInventoryPending } from "../pages/inventory/inventorypendingtabs/tabs-inventorypending";
import { TabInventoryDetails } from "../pages/inventory/inventorydetailstabs/tabs-inventorydetails";

import { OrdersdispatchedPage } from "../pages/orders/ordersdispatched/ordersdispatched";
import { OrdersreceivedPage } from "../pages/orders/ordersreceived/ordersreceived";
import { OrdersdeliveredPage } from "../pages/orders/ordersdelivered/ordersdelivered";
import { CashnotsubmittedPage } from "../pages/orders/cashnotsubmitted/cashnotsubmitted";
import { SettlementPendingPage } from "../pages/orders/settlementpending/settlementpending";
import { CashsettledPage } from "../pages/orders/cashsettled/cashsettled";
import { SingleOrderModal } from "../pages/orders/ordersdispatched/singleordermodal";
import { ProductModal } from "../pages/products/productmodal";
import { ProductServiceProvider } from "../pages/products/product.service";
import { AddOrderServiceProvider } from "../pages/addorder/add-order.service";
import { FarmersPage } from "../pages/farmers/farmers";
import { ManagerPage } from "../pages/manager/manager";
import { InventoryDetailsService } from "../pages/inventory/inventorydetails.service";

import { SqlLiteService } from "../common/services/sqllite.service";

import { SQLite } from "@ionic-native/sqlite";
import { Toast } from "@ionic-native/toast";
import { UserService } from "../services/user.service";
import { NotifyService } from "../services/notify.service";
import { FirebaseService } from "../services/firebase.service";
import { MixpanelService } from "../services/mixpanel.service";

//Add Former

import { AddorderPage } from "../pages/addorder/addorder";
import { CustomerPage } from "../pages/addorder/customer/customer";
import { AddressPage } from "../pages/addorder/address/address";
import { AddCropPage } from "../pages/addorder/addcrop/addcrop";
import { AddMiscPage } from "../pages/addorder/addmisc/addmisc";
import { PlaceOrderPage } from "../pages/addorder/placeorder/placeorder";
import { AddressModalPage } from "../modals/address/address.modal";
import { CropModalPage } from "../modals/crop/crop.modal";

import { MAddressModalPage } from "../modals/maddress/maddress.modal";
import { MissingAddressModalPage } from "../modals/missingaddress/missingaddress.modal";

// Settlement
import { SettlementPage } from "../pages/settlement/settlement";
import { SettlementAllPage } from "../pages/settlement/settlementall/settlementall";
import { SettlementsPendingPage } from "../pages/settlement/settlementspending/settlementspending";
import { SettlementConfirmedPage } from "../pages/settlement/settlementconfirmed/settlementconfirmed";
import { SettlementCancelledPage } from "../pages/settlement/settlementcancelled/settlementcancelled";

// Inventory
import { InventoryPage } from "../pages/inventory/inventory";
import { InventoryAllPage } from "../pages/inventory/inventoryall/inventoryall";
import { InventoryPendingPage } from "../pages/inventory/inventorypending/inventorypending";
import { InventoryPendingStockPage } from "../pages/inventory/inventorypendingstock/inventorypendingstock";
import { InventoryPendingOrdersPage } from "../pages/inventory/inventorypendingorders/inventorypendingorders";
import { InventoryPendingProcurementPage } from "../pages/inventory/inventorypendingprocurement/inventorypendingprocurement";
import { InventoryDetailsStockPage } from "../pages/inventory/inventorydetailsstock/inventorydetailsstock";
import { InventoryDetailsOrdersPage } from "../pages/inventory/inventorydetailsorders/inventorydetailsorders";
import { InventoryDetailsProcurementPage } from "../pages/inventory/inventorydetailsprocurement/inventorydetailsprocurement";

import { DepoModalPage } from "../modals/depo/depo.modal";
import { ProductModalPage } from "../modals/product/product.modal";
import { OrdercancelledPage } from "../pages/orders/ordercancelled/ordercancelled";
import { CustomerModalPage } from "../modals/customer/customer.modal";
import { OrderdetailsModalPage } from "../modals/orderdetails/orderdetails.modal";
import { TabDelivered } from "../pages/orders/orderdeliveredtabs/tabs-delivered";
import { StockReturnModalPage } from "../modals/stockreturn/stockreturn.modal";
import { SubmitCashModalPage } from "../modals/submitcash/submitcash";
import { OrderreceivedModalPage } from "../modals/orderreceived/orderreceived.modal";
import { OrderDeliveredModalPage } from "../modals/orderdelivered/orderdelivered.modal";

import { NotificationPage } from "../pages/notification/notification";

import { ProductSubstitutePage } from "../pages/product-substitute/product-substitute";

import {
  TechnicalModalPage
} from "../modals/technicals/technicals.modal";

import {
  InventoryBreakupModalPage
} from "../modals/inventory-breakup/inventory-breakup.modal";
import { OrderCancelPage } from "../modals/order-cancel/order-cancel";
import { PaymentInfoPage } from "../modals/payment-info/payment-info";
import { PagesBankReceiptPage } from "../pages/pages-bank-receipt/pages-bank-receipt";
import { BankReceiptHistoryPage } from "../pages/bank-receipt-history/bank-receipt-history";
import { ModalsBankReceiptPage } from "../modals/modals-bank-receipt/modals-bank-receipt";
import { TimeConterver } from "../modals/orderdelivered/time-converter/time-converter";
import { BankDetaisHistory } from "../modals/bank-detail-history/bank-detail-history";



@NgModule({
    declarations: [
        MyApp,
        HomePage,
        MapPage,
        LoginPage,
        AddorderPage,
        SettlementPage,
        InventoryPage,
        TabOrder,
        TabAddOrder,
        TabSettlement,
        TabInventory,
        TabInventoryPending,
        TabInventoryDetails,
        ProductsPage,
        BankReceiptHistoryPage,
        PagesBankReceiptPage,
        OrderplacedPage,
        OrdersdispatchedPage,
        CustomerPage,
        SettlementAllPage,
        InventoryAllPage,
        InventoryPendingPage,
        InventoryPendingStockPage,
        InventoryPendingOrdersPage,
        InventoryPendingProcurementPage,
        InventoryDetailsStockPage,
        InventoryDetailsOrdersPage,
        InventoryDetailsProcurementPage,
        SettlementsPendingPage,
        SettlementConfirmedPage,
        SettlementCancelledPage,
        AddressPage,
        AddCropPage,
        AddMiscPage,
        PlaceOrderPage,
        OrdersreceivedPage,
        OrdersdeliveredPage,
        CashnotsubmittedPage,
        SettlementPendingPage,
        CashsettledPage,
        SingleOrderModal,
        SubmitCashModalPage,
        StockReturnModalPage,
        OrderreceivedModalPage,
        OrderDeliveredModalPage,
        OrderCancelPage,
        PaymentInfoPage,
        ProductModal,
        SearchPipe,
        FarmersPage,
        ManagerPage,
        OrdercancelledPage,
        CustomerModalPage,
        OrderdetailsModalPage,
        AddressModalPage,
        MissingAddressModalPage,
        ModalsBankReceiptPage,
        MAddressModalPage,
        CropModalPage,
        ProductModalPage,
        DepoModalPage,
        TabDelivered,
        NotificationPage,
        TimeAgoPipe,
        ProductSubstitutePage,
        TechnicalModalPage,
        InventoryBreakupModalPage,
        TimeConterver,
        BankDetaisHistory
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        NgPipesModule,
        SelectSearchableModule,
        IonicModule.forRoot(MyApp, {
            scrollPadding: false,
            scrollAssist: true,
            autoFocusAssist: false
        }),
        IonicPageModule.forChild(SingleOrderModal),
        IonicPageModule.forChild(CustomerModalPage),
        IonicPageModule.forChild(OrderdetailsModalPage),
        IonicPageModule.forChild(AddressModalPage),
        IonicPageModule.forChild(MissingAddressModalPage),
        IonicPageModule.forChild(PaymentInfoPage),
        IonicPageModule.forChild(MAddressModalPage),
        IonicPageModule.forChild(CropModalPage),
        IonicPageModule.forChild(ProductModalPage),
        IonicPageModule.forChild(DepoModalPage),
        IonicPageModule.forChild(SubmitCashModalPage),
        IonicPageModule.forChild(StockReturnModalPage),
        IonicPageModule.forChild(OrderreceivedModalPage),
        IonicPageModule.forChild(OrderCancelPage),

        ConfirmationPopoverModule.forRoot({
            confirmButtonType: "danger", // set defaults here
            placement: "left"
        }),
        IonicPageModule.forChild(OrderDeliveredModalPage),
        // IonicStorageModule.forRoot({
        //     name: "gramophone-field-app",
        //     driverOrder: ["indexeddb", "sqlite", "websql"]
        // }),
        NgxDatatableModule,
        TimeagoModule.forRoot(),
        AvatarModule.forRoot(), 
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage,
        MapPage,
        LoginPage,
        AddorderPage,
        SettlementPage,
        TabOrder,
        TabAddOrder,
        TabSettlement,
        TabInventory,
        TabInventoryPending,
        PagesBankReceiptPage,
        TabInventoryDetails,
        ModalsBankReceiptPage,
        ProductsPage,
        OrderplacedPage,
        OrdersdispatchedPage,
        CashnotsubmittedPage,
        SettlementPendingPage,
        CashsettledPage,
        CustomerPage,
        SettlementAllPage,
        InventoryAllPage,
        InventoryPendingPage,
        InventoryPendingStockPage,
        InventoryPendingOrdersPage,
        InventoryPendingProcurementPage,
        InventoryDetailsStockPage,
        InventoryDetailsOrdersPage,
        InventoryDetailsProcurementPage,
        SettlementsPendingPage,
        SettlementConfirmedPage,
        SettlementCancelledPage,
        BankReceiptHistoryPage,
        AddressPage,
        AddCropPage,
        AddMiscPage,
        PlaceOrderPage,
        OrdersreceivedPage,
        OrdersdeliveredPage,
        ProductModal,
        FarmersPage,
        ManagerPage,
        OrdercancelledPage,
        CustomerModalPage,
        SubmitCashModalPage,
        StockReturnModalPage,
        OrderreceivedModalPage,
        OrderDeliveredModalPage,
        OrderCancelPage,
        PaymentInfoPage,
        OrderdetailsModalPage,
        AddressModalPage,
        MissingAddressModalPage,
        MAddressModalPage,
        CropModalPage,
        ProductModalPage,
        DepoModalPage,
        TabDelivered,
        NotificationPage,
        ProductSubstitutePage,
        TechnicalModalPage ,
        OrderCancelPage,
        InventoryBreakupModalPage ,
        BankDetaisHistory  ],
    exports: [
        SingleOrderModal,
        CustomerModalPage,
        OrderdetailsModalPage,
        AddressModalPage,
        MissingAddressModalPage,
        MAddressModalPage,
        OrderCancelPage,
        CropModalPage,
        PaymentInfoPage,
        ProductModalPage,
        DepoModalPage,
        SubmitCashModalPage,
        StockReturnModalPage,
        OrderDeliveredModalPage,
        OrderreceivedModalPage,
        TechnicalModalPage,
        ModalsBankReceiptPage,
        InventoryBreakupModalPage
    ],
    providers: [
        StatusBar,
        SplashScreen,
        Keyboard,
        NotifyService,
        InventoryDetailsService,
        Network,
        Geolocation,
        BackgroundMode,
        BackgroundGeolocation,
        Diagnostic,
        APIServiceProvider,
        HelperServiceProvider,
        SqlLiteService,
        ProductServiceProvider,
        AddOrderServiceProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptureService,
            multi: true
        },
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        SQLite,
        Toast,
        UserService,
        FirebaseService,
        MixpanelService,
        LocationTracker,
        SocketioService,
        NotificationsService,
        Shutdown,
        AppVersion,
        Market,
        Mixpanel
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts